import { SvgIcon, SvgIconProps } from '@mui/material';

import './ccf-chat-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfChatIconProps extends SvgIconProps  {
  fillColor?: string;
}

/**
 * Component for displaying chat svg icon
 * @param props -CcfChatIconProps
 * @returns chat svg icon
 * @example -<CcfChatIcon>
 */
export function CcfChatIcon(props: CcfChatIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_comments">
        <path
          id="chat-inbound"
          d="M129.678-42h-5.356A6.3,6.3,0,0,0,118-35.726v.108a6.3,6.3,0,0,0,6.322,6.274H126.9l5.519,3.964a.561.561,0,0,0,.59.02.545.545,0,0,0,.269-.464L132.453-30A6.252,6.252,0,0,0,136-35.615v-.108A6.3,6.3,0,0,0,129.678-42Z"
          transform="translate(-118 42)"
          fill={props.fillColor ? props.fillColor : '#57a0f8'}
        />
      </g>
    </SvgIcon>
  );
}

export default CcfChatIcon;
